'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxDefine = require('redux-define');

var REQUEST = ['PENDING', 'FULFILLED', 'REJECTED'];

exports.default = function (type, subactions) {
  return (0, _reduxDefine.defineAction)(type, subactions || REQUEST);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/boilerplate/utils/define-action.js
// module id = 576
// module chunks = 0